import { HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonUtilityService } from '@app/services/common-utility.service';
import { ToastService } from '@app/shared/service/toast.service';
import { environment } from '@env/environment';
import { DalService } from '@upr-web-primer/dal';
import { MsGuestsService } from '@upr-web-primer/ms-guests';
import { NotificationService } from '@upr-web-primer/notification';
import { LocalStorageService } from '@upr-web-primer/storage';
import { WINDOW } from '@upr-web-primer/window';
import { get } from 'lodash-es';
import { CookieService } from 'ngx-cookie-service';
import { from } from 'rxjs';

@Component({
  selector: 'app-communication-preferences',
  templateUrl: './communication-preferences.component.html',
  styleUrls: ['./communication-preferences.component.scss'],
})
export class CommunicationPreferencesComponent implements OnInit {
  pageLabels: any;
  uor_promos = false;
  ush_promos = false;
  uhu_promos = false;
  inputChanged = false;
  commPreferenceForm: FormGroup;
  savedSourceId: any;
  preferencesLabels: any;

  constructor(
    public commonUtilityService: CommonUtilityService,
    @Inject('AppRoutes') public appRoutes: any,
    @Inject('GlobalDefaults') public globalDefault: any,
    @Inject('RelativeUrls') private relativeUrls: any,
    public cookieService: CookieService,
    public guestsService: MsGuestsService,
    public notification: NotificationService,
    private formBuilder: FormBuilder,
    public cdr: ChangeDetectorRef,
    public toastService: ToastService,
    private localStorage: LocalStorageService,
    public dal: DalService,
    @Inject('sourceKeys') public sourceKeys: any,
    @Inject(WINDOW) private window: any
  ) {}

  ngOnInit(): void {
    this.pageLabels = this.commonUtilityService?.getResolvedPageData();
    this.loadUserInfo().then((bool) => {
      if (!bool) {
        this.notification.show(this.pageLabels?.['errCode.E019']);
        this.commonUtilityService.eventDDlTrigger(
          this.pageLabels?.['errCode.E019']
        );
        this.commonUtilityService.changeRoute(this.appRoutes.LOGIN, {
          signoff: true,
        });
      }
    });
  }

  /**
   * loadUserInfo-It will go back to My_Profile Page
   */

  bacToAccInfo(): void {
    this.commonUtilityService?.changeRoute(this.appRoutes.MY_PROFILE);
  }
  /**
   * onPrimaryClick-It will set the primary Address
   */

  onPrimaryClick(event: any): void {
    if (event?.target?.id) {
      if (event?.target?.id === 'hollywood') {
        const currentValue = event?.detail === 'checked' ? true : false;
        this.commPreferenceForm?.patchValue({
          hollywood: currentValue,
        });
      }
      if (event?.target?.id === 'orlando') {
        const currentValue = event?.detail === 'checked' ? true : false;
        this.commPreferenceForm?.patchValue({
          orlando: currentValue,
        });
      }
      if (event?.target?.id === 'unleashed') {
        const currentValue = event?.detail === 'checked' ? true : false;
        this.commPreferenceForm?.patchValue({
          unleashed: currentValue,
        });
      }
    }
  }
  /**
   * enableButton-It will use when user changes previous value
   */

  enableButton(): any {
    this.commPreferenceForm.valueChanges.subscribe((currentValue) => {
      if (
        currentValue?.hollywood === this.ush_promos &&
        currentValue?.orlando === this.uor_promos &&
        currentValue?.unleashed === this.uhu_promos
      ) {
        this.inputChanged = false;
      } else {
        this.inputChanged = true;
      }
    });
  }

  /**
   * getRelativeUrl-It Will Construct and return Api URL
   */

  getRelativeUrl(url: string, guestId: string): string {
    return url.replace('{guestId}', guestId);
  }

  /**
   * saveChanges-It will save the response
   */
  saveChanges(): void {
    const ush_promos = get(this.commPreferenceForm, 'value.hollywood');
    const uor_promos = get(this.commPreferenceForm, 'value.orlando');
    const uhu_promos = get(this.commPreferenceForm, 'value.unleashed');

    this.savedSourceId = this.commonUtilityService?.getSourceId(
      this.sourceKeys?.WEB_EDITCommunications
    );

    const requestPayload = {
      preferences: {
        comm_prefs: {
          email_offers_promos: uor_promos,
          email_offers_promos_ush: ush_promos,
          opt_in_out: [
            {
              type: 'UOR_EMAIL_OFFERS',
              opt_in: uor_promos,
            },
            {
              type: 'USH_EMAIL_OFFERS',
              opt_in: ush_promos,
            },
            {
              type: 'UHULV_EMAIL_OFFERS',
              opt_in: uhu_promos,
            },
          ],
        },
      },
    };
    const guestId = this.guestsService.helper.getGuestId();
    const url = this.getRelativeUrl(this.relativeUrls.UPDATE_USER, guestId);
    let httpHeaders = new HttpHeaders({});
    httpHeaders = httpHeaders.append('X-Source-Id', this.savedSourceId);
    const eTag = this.localStorage?.getItem('GUESTS-ETAG') || '';
    httpHeaders = httpHeaders.append('If-Match', eTag);
    from(
      this.dal.httpRequest(url, 'PATCH', requestPayload, httpHeaders)
    ).subscribe(
      () => {
        this.toastService.show({
          text: this.pageLabels?.['editCommPreferences.updateSnack'],
          type: this.globalDefault.SUCCESS,
        });
        this.ddlEvents();
        this.commonUtilityService.changeRoute(this.appRoutes.MY_PROFILE);
      },
      (error) => {
        console.error(error);
        if (error.status == this.globalDefault.ERROR_401) {
          this.commonUtilityService.setUser();
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll('/', environment.cookieSubDomain);
          const redirectUrl = this.commonUtilityService.getOidcRedirectionUrl();
          this.commonUtilityService.redirectToOidcAppEndSession(redirectUrl);
        } else {
          this.commonUtilityService.notifyFormErrorEvent(
            this.pageLabels?.['accountInfo.communicationPreferences'],
            this.pageLabels?.['errCode.E004']
          );
          this.ddlEvents();
          this.toastService.show({
            text: this.pageLabels?.['errCode.E007'],
            type: this.pageLabels?.['trpAdd.warning'],
          });
        }
      }
    );
  }

  /**
   * setFormValues - set and patch the form values
   */

  setFormValues(): void {
    this.commPreferenceForm?.patchValue({
      hollywood: this.ush_promos,
      orlando: this.uor_promos,
      unleashed: this.uhu_promos,
    });
  }

  /**
   * createForm - it will create the form with input fields
   */

  createForm(): any {
    this.commPreferenceForm = this.formBuilder.group({
      hollywood: new FormControl(),
      orlando: new FormControl(),
      unleashed: new FormControl(),
    });
  }

  /**
   * loadUserInfo-It will load the User_profileData
   */

  public loadUserInfo(): Promise<boolean> {
    const guestId = this.guestsService?.helper?.getGuestId();
    this.preferencesLabels = {
      UOR_EMAIL_OFFERS: this.pageLabels?.['accountInfo.universalOrlando'],
      USH_EMAIL_OFFERS: this.pageLabels?.['accountInfo.universalHollywood'],
      UHULV_EMAIL_OFFERS: this.pageLabels?.['accountInfo.universalUnleashed'],
    };
    return this.guestsService.preferences
      .getPreferences(guestId)
      .then((userData: any) => {
        if (!userData) {
          return false;
        }
        const preferenceKeys = Object.keys(this.preferencesLabels);
        if (userData?.comm_prefs?.opt_in_out) {
          userData?.comm_prefs?.opt_in_out.forEach((element: any) => {
            if (element.type === preferenceKeys[0]) {
              this.uor_promos =
                element?.opt_in || userData?.comm_prefs?.email_offers_promos;
            }
            if (element.type === preferenceKeys[1]) {
              this.ush_promos =
                element?.opt_in ||
                userData?.comm_prefs?.email_offers_promos_ush;
            }
            if (element.type === preferenceKeys[2]) {
              this.uhu_promos = element?.opt_in;
            }
          });
        } else {
          this.uor_promos = this.ush_promos = this.uhu_promos = false;
        }

        this.createForm();
        this.setFormValues();
        this.enableButton();
        this.cdr.detectChanges();
        return true;
      })
      .catch((error: any) => {
        if (error.status == this.globalDefault.ERROR_401) {
          this.commonUtilityService.setUser();
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll('/', environment.cookieSubDomain);
          const redirectUrl = this.commonUtilityService.getOidcRedirectionUrl();
          this.commonUtilityService.redirectToOidcAppEndSession(redirectUrl);
          return false;
        }
        return true;
      });
  }

  /**
   * ddlEvents - On phone number update these events are getting set
   * @param type - On api response success or failed
   */
  ddlEvents(): void {
    this.commonUtilityService.invokeFireEvent(
      this.pageLabels?.['addAddress.save'],
      'Button',
      'Click',
      '',
      new Date().toISOString(),
      'Body | CTA:' + this.pageLabels?.['addAddress.save'],
      '',
      this.window?.digitalData?.page?.category?.primaryCategory ?? '',
      this.window?.digitalData?.page?.category?.subCategory1 ?? ''
    );
    // this.commonUtilityService?.setUser();
  }
}
